var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCottagesAndCampsites = function SvgCottagesAndCampsites(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.462,
    height: 25.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Cottages and campsite",
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 406",
    stroke: "#102b3f",
    strokeWidth: 2,
    d: "M1.212 16.48h14.75"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 407",
    stroke: "#102b3f",
    strokeWidth: 2,
    d: "M19.962 16.48h8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 400",
    stroke: "#102b3f",
    strokeWidth: 2,
    d: "M23.962 15.98v-6"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 486",
    transform: "translate(18.462)",
    stroke: "#102b3f",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8899"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3598",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 3.48h9a2 2 0 0 1 2 2l1 6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5.48v6h9.972l-.945-5.671A2 2 0 0 1 11 5.48H2m0-2h9a2 2 0 0 1 2 2l1 6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2Z",
    fill: "#102b3f"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 487",
    transform: "translate(5 11.48)",
    stroke: "#102b3f",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 401",
    stroke: "#102b3f",
    strokeWidth: 2,
    d: "M9.5 12.98h7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 402",
    stroke: "#102b3f",
    strokeWidth: 2,
    d: "M4.5 7.98v4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 403",
    stroke: "#102b3f",
    strokeWidth: 2,
    d: "M7.5 7.98h0"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8900",
    stroke: "#102b3f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 399",
    d: "M8.962 24.5h16.75"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 404",
    d: "m15.962 11.98 8.5 12"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 405",
    d: "m19.712 11.98-8.5 12"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3599",
    d: "m15.658 23.98 2.238-3.49 1.12 1.521",
    strokeLinejoin: "round"
  })))));
};
export default SvgCottagesAndCampsites;